import { ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { UpLoadingFilterForm } from './Uploading-filter-form';
type MatrialTopBarProps = {
  getInitialFilterValues: any;
  handleFilter: (values: any) => void;
  showAppUserModal: any;
  setShowAppUserModal: any
  onRefresh: () => void;
};

export const UpLoadingLogViewTopBar = ({
  getInitialFilterValues,
  handleFilter,
  onRefresh
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';

  return (
    <>
      <ContentTopBar title={'Unloading Logs'} />
      <ContentFilters formId={formId}>
        <UpLoadingFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
